import React, { useRef, useState } from "react"
import { CircleButton } from "@shared"
import Styles from "./videoURL.module.scss"

const VideoURL = ({ src }) => {
  const playerRef = useRef()
  const [playing, setPlaying] = useState(false)

  const togglePlaying = () => {
    // reset video to start from beginning
    const startPosition = 0
    playerRef.current.currentTime = startPosition
    setPlaying(true)
  }

  return (
    <div className={Styles.container}>
      <div className={Styles.buttonContainer}>
        {!playing && (
          <CircleButton
            color="blue"
            size="medium"
            className={Styles.pausePlayButton}
            content="play"
            label="Play"
            onClick={togglePlaying}
          />
        )}
      </div>
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <video
        ref={playerRef}
        controlsList="nodownload"
        className={Styles.video}
        autoPlay={!playing}
        playsInline
        loop={!playing}
        controls={playing}
        muted={!playing}
      >
        <source src={src} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  )
}

export default VideoURL
